import type { ApiRouteDefinition, AuthConfig } from '@auth0/auth0-angular';
import { environment } from '@/environments/environment';

const API_SCOPE = 'openid profile email';

export function getApiBaseUrl(): string {
  const prName = getPullRequestName(window.location.href);
  if (prName) {
    return `https://api-statusnow-portal-dev-${prName}.azurewebsites.net`;
  }

  return environment.backendServerUrl;
}

/**
 * Where SignalR hubs live. Every build uses the API it calls, except the regional pilot
 * build, which sets `hubServerUrl` to keep its hubs on the stack that sends live updates
 * (docs/execplans/regional-staff-pilot.md).
 */
export function getHubBaseUrl(): string {
  if ('hubServerUrl' in environment && typeof environment.hubServerUrl === 'string') {
    return environment.hubServerUrl;
  }

  return getApiBaseUrl();
}

export function getAuthConfig(): AuthConfig {
  const config = environment.auth as AuthConfig;
  const allowedList = buildAllowedList(config.httpInterceptor?.allowedList);
  const prName = getPullRequestName(window.location.href);

  if (prName) {
    allowedList.push(createApiRouteDefinition(getPrApiBaseUrl(prName)));
  }

  return {
    ...config,
    authorizationParams: {
      ...config.authorizationParams,
    },
    httpInterceptor: {
      ...config.httpInterceptor,
      allowedList,
    },
  };
}

function buildAllowedList(
  allowedList: ApiRouteDefinition[] | undefined
): ApiRouteDefinition[] {
  return (allowedList ?? []).map((route) =>
    typeof route === 'string'
      ? route
      : {
          ...route,
          tokenOptions: route.tokenOptions
            ? {
                ...route.tokenOptions,
                authorizationParams: {
                  ...route.tokenOptions.authorizationParams,
                },
              }
            : route.tokenOptions,
        }
  );
}

function createApiRouteDefinition(apiBaseUrl: string): ApiRouteDefinition {
  return {
    uri: `${apiBaseUrl}/*`,
    tokenOptions: {
      authorizationParams: { scope: API_SCOPE },
    },
  };
}

function getPrApiBaseUrl(prName: string): string {
  return `https://api-statusnow-portal-dev-${prName}.azurewebsites.net`;
}

function getPullRequestName(url: string): string | null {
  if (!url.startsWith('https://pr-')) {
    return null;
  }

  return url.split('.')[0]?.replace('https://', '') ?? null;
}
